module.exports = __webpack_public_path__ + "static/feature-2-c7e527c8a2e463aca0bb365a05dca107.svg";